import { render, staticRenderFns } from "./goodWaterfallSetting.vue?vue&type=template&id=3168ada1&scoped=true"
import script from "./goodWaterfallSetting.vue?vue&type=script&lang=js"
export * from "./goodWaterfallSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168ada1",
  null
  
)

export default component.exports